module.exports = __webpack_public_path__ + "static/media/Sophie.02244391.png";